if(!customElements.get('strata-multibuy'))customElements.define('strata-multibuy',class extends HTMLElement{
 connectedCallback(){
  if(this.controller)return;this.controller=new AbortController();this.busy=false;
  this.form=this.querySelector('[data-set-form]');this.status=this.querySelector('[data-set-status]');this.button=this.querySelector('button[type=submit]');this.slots=[...this.querySelectorAll('[data-set-slot]')];
  const signal=this.controller.signal;
  this.slots.forEach((slot,i)=>{const select=slot.querySelector('select');if(!select.value){const options=[...select.options].filter(o=>o.value&&!o.disabled);if(options.length)select.value=options[i%options.length].value;}});
  this.form.hidden=false;
  this.form.addEventListener('change',()=>this.update(),{signal});
  this.form.addEventListener('submit',e=>this.submit(e),{signal});this.update();
 }
 update(){
  const count=Number(this.querySelector('input[type=radio]:checked')?.value||2);
  const gallery=[...this.querySelectorAll('[data-set-gallery-slot]')];let total=0,complete=true;
  this.slots.forEach((slot,i)=>{
   slot.hidden=i>=count;const select=slot.querySelector('select');select.disabled=i>=count;select.required=i<count;
   const option=select.selectedOptions[0];const image=gallery[i].querySelector('img');
   gallery[i].hidden=i>=count;gallery[i].dataset.edition=option?.dataset.edition||'';
   if(option?.dataset.image){if(image.getAttribute('src')!==option.dataset.image)image.src=option.dataset.image;image.hidden=false;}else{image.hidden=true;image.removeAttribute('src');}
   gallery[i].querySelector('[data-set-placeholder]').hidden=!image.hidden;
   if(i<count){if(!select.value)complete=false;total+=Number(option?.dataset.price||0);}
  });
  const format=value=>{try{return new Intl.NumberFormat(this.dataset.locale||'en',{style:'currency',currency:this.dataset.currency||'CHF'}).format(value/100);}catch{return (value/100).toFixed(2)+' '+(this.dataset.currency||'CHF');}};
  const requested=this.dataset.currency==='CHF'?Number(count===2?this.dataset.discountTwo:this.dataset.discountThree):0;
  const saving=Math.min(total,Math.max(0,requested||0));
  this.querySelector('[data-set-count]').textContent='0'+count;
  this.querySelector('[data-set-total]').textContent=complete?format(total-saving):'Choose your decks';
  const original=this.querySelector('[data-set-original]');original.hidden=!complete||saving<=0;original.textContent=format(total);
  this.querySelector('[data-set-saving]').textContent=complete&&saving>0?'Save '+format(saving):'';
  this.querySelectorAll('[data-tier-total]').forEach(label=>{
   const size=Number(label.dataset.tierTotal);const picks=this.slots.slice(0,size).map(slot=>slot.querySelector('select').selectedOptions[0]);
   if(picks.some(option=>!option?.value)){label.textContent='';return;}
   const subtotal=picks.reduce((sum,option)=>sum+Number(option.dataset.price||0),0);
   const discount=this.dataset.currency==='CHF'?Math.max(0,Number(size===2?this.dataset.discountTwo:this.dataset.discountThree)||0):0;
   label.textContent=format(Math.max(0,subtotal-discount));
  });
  this.dataset.count=String(count);
 }
 async submit(event){
  event.preventDefault();if(this.busy||!this.form.reportValidity())return;
  const selected=this.slots.filter(s=>!s.hidden).map(s=>s.querySelector('select'));
  if(![2,3].includes(selected.length))return;
  const quantities=new Map();
  for(const select of selected){const id=select.value;if(!/^\d+$/.test(id)||![...select.options].some(o=>o.value===id&&!o.disabled))return;quantities.set(id,(quantities.get(id)||0)+1);}
  const items=[...quantities].map(([id,quantity])=>({id,quantity}));
  this.busy=true;this.button.disabled=true;this.status.textContent='Adding your set…';
  try{
   const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
   const result=await response.json();
   if(!response.ok)throw new Error(result.description||result.message||'This set could not be added. Check the options and try again.');
   this.status.textContent='Set added. Opening your bag…';window.location.assign(this.dataset.cartUrl);
  }catch(error){if(this.isConnected){this.status.textContent=error.message+' Please check your bag before retrying.';this.button.disabled=false;this.busy=false;}}
 }
 disconnectedCallback(){this.controller?.abort();this.controller=null;}
});
